import React from "react";
import {useStyles} from "./styles/ComponentsStyle";
import {Box, Step, StepLabel, Stepper} from "@material-ui/core";
import clsx from "clsx";
import {inject, observer} from "mobx-react";

function EduContentsTopStepper(props) {
    const {steps, activeStep} = props;
    const classes = useStyles();


    function ColorlibStepIcon(props) {
        const {active, completed} = props;
        const icons = {
            1: 1,
            2: 2,
            3: 3,
            4: 4,
            5: 5,
            6: 6,
            7: 7,
        };

        return (
            <div className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}>
                {completed ? <div className={classes.completed}/> : <div className={classes.active}/>}
                {icons[String(props.icon)]}
            </div>
        );
    }

    return (
        <div className={classes.root}>
            <Box className={classes.topBox}>
                <Stepper activeStep={activeStep} alternativeLabel className={classes.activeStepIcon}>
                    {!!steps.length && steps.map((step) => (
                        <Step key={step.step}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>{step.text}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </div>
    );
}
export default inject('contentStore')(observer(EduContentsTopStepper))
